import { useState, useEffect } from 'react';
import { Collapse, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { authenticationService } from '../../services'

export function NavMenu() {
  const [collapsed, setCollapsed] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  }

  useEffect(() => {
    authenticationService.user.subscribe(user => {
      if (user) {
        setIsAdmin(user.isAdmin)
      }
    });
  }, []);

  return (
    <header className="hidden-print">
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark blm-header">
        <NavbarBrand href="https://www.blm.gov">
          <div className="title d-flex-sm-row-reverse">
            <img alt="BLM Logo" height="82" src="/images/BLM_Logo.png" />
            <img alt="Wild Horse and Burro Logo" src="/images/logo.png" />
          </div>
        </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} className="mr-2 text-light" />
        <Collapse className="flex-sm-row-reverse" isOpen={!collapsed} navbar>
          <ul className="navbar-nav flex-grow">
            <NavItem>
              <NavLink tag={Link} className="text-light" to="/">Home</NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} className="text-light" to="/faq">FAQ</NavLink>
            </NavItem>
            <NavItem>
              <a className="text-light nav-link" href="https://wildhorsesonline.blm.gov" target="_blank" rel="noreferrer">Online Corral</a>
            </NavItem>
            <NavItem>
              <a className="text-light nav-link" href="https://www.blm.gov/programs/wild-horse-and-burro/tales-from-the-trails-blog" target="_blank" rel="noreferrer">Testimonials</a>
            </NavItem>
            {isAdmin &&
              <NavItem>
                <NavLink tag={Link} className="text-light" to="/olc">Edit</NavLink>
              </NavItem>
            }
          </ul>
        </Collapse>
      </nav>
      <div className="bottom-header" height="14px" />
    </header>
  );
}

